import React, { useEffect, useState } from "react";
import { base_url } from "../../../utils/AxiosConfig";
import axios from "axios";
import SnackbarNotification from "../../../utils/SnackbarNotification";
import dayjs from "dayjs";

const LeaveRejoinPopup = ({
  setPopUpData,
  PopUpData,
  getDataApproved,
  onClose,
}) => {
  const [earlyOrLate, setEarlyOrLate] = useState(null);
  const [toDate, SetToDate] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [rejoinDate, setRejoinDate] = useState("");

  const today = dayjs().format("YYYY-MM-DD");

  // Keeps the calendar day as-is (no timezone shift) and returns YYYY-MM-DD
  const toDateString = (value) =>
    value ? dayjs(String(value).split("T")[0]).format("YYYY-MM-DD") : "";

  const getEarlyOrLate = (selectedDate, leaveToDate) => {
    if (!selectedDate || !leaveToDate) return null;

    const diff = dayjs(selectedDate)
      .startOf("day")
      .diff(dayjs(leaveToDate).startOf("day"), "day");

    if (diff < 0) return `Early by ${Math.abs(diff)} Days`;
    if (diff > 0) return `Late by ${diff} Days`;
    return "On time";
  };

  useEffect(() => {
    if (PopUpData) {
      const leaveFrom = toDateString(PopUpData?.FromDate);
      const leaveTo = toDateString(PopUpData?.ToDate);

      setFromDate(leaveFrom);
      SetToDate(leaveTo);
      setRejoinDate(today);
      setEarlyOrLate(getEarlyOrLate(today, leaveTo));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [PopUpData]);

  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  const companyCode = storedUserDataArray[0]?.cmpcode || null;

  const handleDateChange = (e) => {
    const selected = e.target.value;
    if (!selected) {
      setRejoinDate("");
      setEarlyOrLate(null);
      return;
    }

    setRejoinDate(selected);
    setEarlyOrLate(getEarlyOrLate(selected, toDate));
  };

  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "success",
    message: "",
  });

  const showSnackbar = (severity, message) => {
    setSnackbar({ open: true, severity, message });
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const SaveRejoinApi = async () => {
    try {
      const response = await axios.post(
        `${base_url}/api/PersonalInfoLeaveStatusUpdate/${companyCode}/REJOIN/${PopUpData?.serialcode || null
        }/${PopUpData?.Name}/${PopUpData?.Ticket || "Not Applicable"
        }/${PopUpData?.approvalnote || "nil"}`,
      );

      if (response?.data) {
        showSnackbar("success", "Rejoin Success");
        setTimeout(() => {
          onClose();
          getDataApproved();
        }, 1000);
      }
    } catch (error) {
      showSnackbar("error", "Rejoin Error");
      console.error("SaveRejoinApiErr", error);
    }
  };

  return (
    <>


      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        <div className="bg-white w-full max-w-2xl rounded-lg shadow-lg">
          {/* Header */}
          <div className="flex items-center justify-between border-b px-5 py-3 bg-[#2663EB] rounded-t-lg">
            <h5 className="text-lg font-semibold text-white">Rejoin Update</h5>

            <button
              onClick={onClose}
              className="text-white hover:text-gray-800 text-3xl"
            >
              &times;
            </button>
          </div>

          {/* Body */}
          <div className="p-4">
            {/* <p className="text-sm text-gray-500 mb-4">Rejoin</p> */}

            <div className="overflow-x-auto scrollbar-none rounded-sm m-2">
              <table className="w-full text-sm border border-gray-200 ">
                <tbody className="divide-y">
                  <tr>
                    <td className="p-2 font-medium">Leave Taken</td>
                    <td className="p-2">{PopUpData?.Leave_Category}</td>
                  </tr>

                  <tr>
                    <td className="p-2 font-medium">Leave From</td>
                    <td className="p-2">
                      {/* <input
                        className="w-full border rounded-md px-2 py-1 text-sm bg-gray-100"
                        type="date"
                        value={PopUpData?.FromDate?.split("T")[0]}
                        disabled
                      /> */}
                      <input
                        type="date"
                        className="w-full border rounded-md px-2 py-1 text-sm bg-gray-100"
                        value={fromDate}
                        disabled
                      />
                    </td>
                  </tr>

                  <tr>
                    <td className="p-2 font-medium">Leave To</td>
                    <td className="p-2">
                      <input
                        className="w-full border rounded-md px-2 py-1 text-sm bg-gray-100"
                        type="date"
                        value={toDate}
                        disabled
                      />
                    </td>
                  </tr>

                  <tr>
                    <td className="p-2 font-medium">Rejoined On</td>
                    <td className="p-2">
                      <input
                        type="date"
                        className="w-full border border-gray-300 rounded-md px-2 py-1 text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 focus:outline-none"
                        value={rejoinDate || ""}
                        onChange={handleDateChange}
                      // min={fromDate || undefined}
                      // max={today}
                      />
                    </td>
                  </tr>

                  <tr>
                    <td className="p-2 font-medium">Early Or Late By</td>
                    <td className="p-2">
                      <span className="text-blue-600 font-semibold">
                        {earlyOrLate || "N/A"}
                      </span>
                    </td>
                  </tr>

                  <tr className=" "></tr>
                </tbody>
              </table>
            </div>
            <div className="mt-4 w-full flex justify-center items-center">
              <button
                onClick={SaveRejoinApi}
                className="bg-blue-600 hover:bg-blue-700 text-white text-sm px-4 py-1.5 rounded-md transition"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Snackbar */}
      <SnackbarNotification
        open={snackbar.open}
        severity={snackbar.severity}
        message={snackbar.message}
        onClose={handleCloseSnackbar}
      />
    </>
  );
};

export default LeaveRejoinPopup;
